import React, {useState} from "react"
import {Tabs} from "antd"
import {TabHeader} from "components/Tab"
import {CheckList} from "sections/Settings"
import {useModel} from "hooks"
import {DepartmentFormSettings} from "sections/Settings/DepartmentForm"

const {TabPane} = Tabs

enum Tab {
    Checklist = "checklist",
    Form = "form"
}

export function ChecklistSettings(props) {
    const [activeTabKey, onChangeTab] = useState<string>(Tab.Checklist)
    const model = useModel()

    return (
        <Tabs className="fullwidth klassSubTab" activeKey={activeTabKey} onChange={onChangeTab}>
            <TabPane tab={<TabHeader title="Checklists" />} key={Tab.Checklist}>
                {activeTabKey === Tab.Checklist && (
                    <CheckList {...props} departmentId={props.departmentId} model={model} />
                )}
            </TabPane>
            <TabPane tab={<TabHeader title="Forms" />} key={Tab.Form}>
                {activeTabKey === Tab.Form && (
                    <DepartmentFormSettings {...props} departmentId={props.departmentId} model={model} />
                )}
            </TabPane>
        </Tabs>
    )
}
